import React from "react";
import { useNavigate } from "react-router-dom";
import { objToFormData } from "../../../helpers/FormHelper";
import { createAddonTemplate } from "../../../actions/mods_factory/addonTemplatesActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewError, setNewParams, AddonTemplateInterface } from "../../../store/mods_factory/addonTemplatesSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const navigate    = useNavigate();
  const dispatch    = useAppDispatch();
  const newParams   = useAppSelector(state => state.modsFactory.addonTemplates.newParams);
  const error       = useAppSelector(state => state.modsFactory.addonTemplates.newError);
  const categories  = useAppSelector(state => state.modsFactory.categories.entities);

  let params = newParams;

  if (categories && newParams?.category_id) {
    const category = categories[newParams.category_id];
    params = { ...newParams };

    if (category?.parent_id) {
      params.category_id    = category.parent_id;
      params.subcategory_id = category.id;
    }
  }

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: AddonTemplateInterface) {
    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createAddonTemplate(data));

    if (createAddonTemplate.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-addonTemplate'>
        <h6 className="v-content-label">Create AddonTemplate</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
